import { render, staticRenderFns } from "./PoiOverview.vue?vue&type=template&id=f168ce64"
import script from "./PoiOverview.js?vue&type=script&lang=js&external"
export * from "./PoiOverview.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports